<template>
    <div class="pa-5">
        <h1 class="fonte text-uppercase mb-3">Integração API Astandes</h1>

        <h2 class="text-uppercase mb-4 ml-3" v-show="false">Introdução</h2>
        <h3>Com o Astandes você pode integrar o envio de SMS a  interface do seu sistema atual. Ganhando comodidade e praticidade ao enviar mensagens unitárias ou SMS's em massa.</h3>
        <v-divider class="mt-3 mb-5"></v-divider>
        <v-expansion-panel>
            <v-expansion-panel-content

            >
            <template v-slot:header>
                <div>Envio de Mensagens</div>
            </template>
            <v-card>
            <v-chip label color="primary ma-3" text-color="white" style="border-radius: 5px;">
                POST
            </v-chip>
            <v-sheet color="grey lighten-2 pa-3 ma-3">
                Rota: https://api.astandes.com.br/api/v1/message
            </v-sheet>
            <v-tabs
                color="fundo"
                dark
            >
                <v-tabs-slider color="white"></v-tabs-slider>

                <v-tab href="#tab-1"> CURL </v-tab>
                <v-tab  href="#tab-2">PHP</v-tab>
                <v-tab href="#tab-3">NODE.JS</v-tab>
                <v-tab href="#tab-4">Python</v-tab>
                <v-spacer></v-spacer>

                <v-tab>Envio Simples</v-tab>

                <v-tabs-items>
                    <v-tab-item value="tab-1">
                        <v-card flat class="pa-3">
                            <v-sheet color="grey lighten-2 pa-3 ml-1 mt-2 mb-3" style="overflow-x:auto;">
                                <pre>
    curl https://api.astandes.com.br/api/v1/message \
     -X POST \
     -H "Authorization: {{getUserLocal.key}}" \
     -d \
    '{
        "phone": ['16993524533', '16998273544'],
        "text": "Hello world!"
    }'
                                </pre>
                            </v-sheet>
                            <v-data-table
                                :items="camposSimples"
                                class="elevation-1"
                                :headers="headers"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.campo }}</td>
                                <td class="text-xs-left">{{ props.item.desc }}</td>
                                <td class="text-xs-center">{{ props.item.tipo }}</td>
                                <td class="text-xs-right">{{ props.item.requerido }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-2">
                        <v-card flat class="pa-3">
                            <v-sheet color="grey lighten-2 pa-3 ml-1 mt-2 mb-3" style="overflow-x:auto;">
                                <pre>
    <?php
        $curl = curl_init();

        $dados = [
            "text" => "Teste de envio",
            "phone" => ['16993524533', '16998273544']
        ];

        curl_setopt_array($curl, [
            CURLOPT_URL => "https://api.astandes.com.br/api/v1/message",
            CURLOPT_CUSTOMREQUEST => "POST",
            CURLOPT_POSTFIELDS => json_encode($dados),
            CURLOPT_HTTPHEADER => [
                "authorization: {{getUserLocal.key}} ",
                "content-type: application/json"
            ],
        ]);

        $response = curl_exec($curl);
        $err = curl_error($curl);
        curl_close($curl);

        if ($err) {
            echo "cURL Error #:" . $err;
        } else {
            echo $response;
        }
                                </pre>
                            </v-sheet>
                            <v-data-table
                                :items="camposSimples"
                                class="elevation-1"
                                :headers="headers"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.campo }}</td>
                                <td class="text-xs-left">{{ props.item.desc }}</td>
                                <td class="text-xs-center">{{ props.item.tipo }}</td>
                                <td class="text-xs-right">{{ props.item.requerido }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-3">
                        <v-card flat class="pa-3">
                            <v-sheet color="grey lighten-2 pa-3 ml-1 mt-2 mb-3" style="overflow-x:auto;">
                                <pre>
    const request = require('request')

    let dados = {
        text: "Testando node",
        phone: ['16993524533', '16998273544']
    }

    const options = {
        url: 'https://api.astandes.com.br/api/v1/message',
        headers: {
            "authorization": "{{getUserLocal.key}}"
        },
        method: 'POST',
        body: dados,
        json: true
    }

    request(options, (error, body, response) => {
        if(error) throw error
        console.log(response)
    })
                                </pre>
                            </v-sheet>
                            <v-data-table
                                :items="camposSimples"
                                class="elevation-1"
                                :headers="headers"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.campo }}</td>
                                <td class="text-xs-left">{{ props.item.desc }}</td>
                                <td class="text-xs-center">{{ props.item.tipo }}</td>
                                <td class="text-xs-right">{{ props.item.requerido }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-tab-item>
                    <v-tab-item value="tab-4">
                        <v-card flat class="pa-3">
                            <v-sheet color="grey lighten-2 pa-3 ml-1 mt-2 mb-3" style="overflow-x:auto;">
                                <pre>
    import requests

    dados = {
        "text": "Testando node",
        "phone": ['16993524533', '16998273544']
    }

    r = requests.post(
        "https://api.astandes.com.br/api/v1/message",
        data = dados,
        headers = {
            "authorization": "{{getUserLocal.key}}"
        }
    )

    data = r.json()

    print(data)
                                </pre>
                            </v-sheet>
                            <v-data-table
                                :items="camposSimples"
                                class="elevation-1"
                                :headers="headers"
                                hide-actions
                            >
                                <template v-slot:items="props">
                                <td class="text-xs-left">{{ props.item.campo }}</td>
                                <td class="text-xs-left">{{ props.item.desc }}</td>
                                <td class="text-xs-center">{{ props.item.tipo }}</td>
                                <td class="text-xs-right">{{ props.item.requerido }}</td>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-tab-item>
                </v-tabs-items>
            </v-tabs>
            </v-card>
            </v-expansion-panel-content>



            <v-expansion-panel-content>
                <template v-slot:header>
                    <div>Webhook para respostas de sms</div>
                </template>

                <v-card class="pa-5">
                    <p>Havendo uma resposta ao sms enviado, o sistema astandes enviará uma requisição HTTPS ao endereço cadastrado abaixo:</p>
                    <div class="body-content">
                    <p><strong>O Método de requisição é do tipo POST</strong></p>
                    <p><strong>Modelo de envio do json:</strong></p>
                                <pre>

    {
        "message": "mensagem de resposta",
        "phone": '16998273544'
    }
                                </pre>
                    </div>
                    <v-text-field :rules="[ () => isValidUrl || 'Url inválida' ]" color="blue-grey" label="Endereço de recebimento de resposta" v-model="uri_response_sms"></v-text-field>
                    <v-btn @click="save" class="ml-0 teal" :disabled="!isValidUrl" dark>Salvar</v-btn>
                </v-card>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
  export default {
    data () {
      return {
        tab: null,
        tab2: null,
        headers: [
            { text: 'Campo', value: 'campo', align: 'left', sortable: false, },
            { text: 'Descrição', value: 'descricao', align: 'left', sortable: false, },
            { text: 'Tipo', value: 'tipo', align: 'center', sortable: false, },
            { text: 'Requerido', value: 'requerido', align: 'right', sortable: false, },
        ],
        camposSimples: [
            {campo: 'text', desc: 'Mensagem a ser enviada', tipo: 'string', requerido: 'SIM'},
            {campo: 'phone', desc: 'Número do destinatário do SMS', tipo: 'string ou array', requerido: 'SIM'}
        ],
        api: [
            'Envio de Mensagens', 'Listar Mensagens', 'Código de Status'
        ],
        items: [
          'Curl', 'PHP', 'NodeJS', 'Python'
        ],
        token: '',
        uri_response_sms:''
      }
    },
    async mounted()
    {
        await this.loadUserLocal(this.$store.getters.getUser._id)
        this.uri_response_sms = this.getUserLocal.uri_response_sms
    },
    methods: {
        ...mapActions(['loadUserLocal', 'save_webhook_response_sms']),
        async save()
        {
            this.$eventHub.emit('snackBar', {
                message: ( await this.save_webhook_response_sms({_id: this.getUserLocal._id, uri_response_sms:this.uri_response_sms}) ) ? 'Operação realizada com sucesso' : 'Não foi possível realizar operação'
            })
            await this.loadUserLocal(this.$store.getters.getUser._id)
        }
    },
    computed: {
        ...mapGetters(['getUserLocal']),
        isValidUrl()
        {
            try {
                new URL(this.uri_response_sms)
                return true
            } catch (_) {
                return false
            }
        }
    }
  }
</script>


<style lang="stylus">
    .body-content
        background-color #eee
        padding 20px
</style>



// WEBPACK FOOTER //
// src/components/Documentacao.vue